
import { Link } from "react-router-dom";

export default function Footer() {

  return (
    <footer id="clients" className="bg-red-500 lg:rounded-tl-[100px]">
      {/* client */}
      <div className="py-10 lg:px-[55px] lg:py-20 px-3">
        <div className="flex flex-wrap lg:mb-20 lg:flex-nowrap">
            <h2 className="font-bold text-white text-3xl lg:text-4xl mb-3 lg:mr-20 ">Media Partner</h2>
            <p className=" text-white mb-10 lg:mb-0 max-w-[630px] lg:text-xl text-[15px]">
                Media partner yang mendukung dan turut berkontribusi dalam memperluas jangkauan serta apresiasi terhadap karya-karya yang kami ciptakan.
            </p>
        </div>

        {/* imgClient */}
        <div className="overflow-hidden w-[100%]">
          <div className="animate-marquee flex justify-evenly gap-x-8 [animation-duration:20s] lg:[animation-duration:40s]">
            <div className="relative h-12 lg:h-24 w-[calc(100%/4)] flex-shrink-0 select-none md:w-[calc(100%/6)] lg:w-[calc(100%/8)] bg-white rounded-lg p-2">
              <img className="pointer-events-none h-full w-full select-none object-contain" src="/images/medpart/1.png" alt="client"/>
            </div>

            <div className="relative h-12 lg:h-24 w-[calc(100%/4)] flex-shrink-0 select-none md:w-[calc(100%/6)] lg:w-[calc(100%/8)] bg-white rounded-lg p-2">
              <img className="pointer-events-none h-full w-full select-none object-contain" src="/images/medpart/2.png" alt="client"/>
            </div>

            <div className="relative h-12 lg:h-24 w-[calc(100%/4)] flex-shrink-0 select-none md:w-[calc(100%/6)] lg:w-[calc(100%/8)] bg-white rounded-lg p-2">
              <img className="pointer-events-none h-full w-full select-none object-contain" src="/images/medpart/3.png" alt="client"/>
            </div>

            <div className="relative h-12 lg:h-24 w-[calc(100%/4)] flex-shrink-0 select-none md:w-[calc(100%/6)] lg:w-[calc(100%/8)] bg-white rounded-lg p-2">
              <img className="pointer-events-none h-full w-full select-none object-contain" src="/images/medpart/4.png" alt="client"/>
            </div>

            <div className="relative h-12 lg:h-24 w-[calc(100%/4)] flex-shrink-0 select-none md:w-[calc(100%/6)] lg:w-[calc(100%/8)] bg-white rounded-lg p-2">
              <img className="pointer-events-none h-full w-full select-none object-contain" src="/images/medpart/5.png" alt="client"/>
            </div>
                        
            <div className="relative h-12 lg:h-24 w-[calc(100%/4)] flex-shrink-0 select-none md:w-[calc(100%/6)] lg:w-[calc(100%/8)] bg-white rounded-lg p-2">
              <img className="pointer-events-none h-full w-full select-none object-contain" src="/images/medpart/6.png" alt="client"/>
            </div>

            <div className="relative h-12 lg:h-24 w-[calc(100%/4)] flex-shrink-0 select-none md:w-[calc(100%/6)] lg:w-[calc(100%/8)] bg-white rounded-lg p-2">
              <img className="pointer-events-none h-full w-full select-none object-contain" src="/images/medpart/7.png" alt="client"/>
            </div>

            <div className="relative h-12 lg:h-24 w-[calc(100%/4)] flex-shrink-0 select-none md:w-[calc(100%/6)] lg:w-[calc(100%/8)] bg-white rounded-lg p-2">
              <img className="pointer-events-none h-full w-full select-none object-contain" src="/images/medpart/8.png" alt="client"/>
            </div>

            <div className="relative h-12 lg:h-24 w-[calc(100%/4)] flex-shrink-0 select-none md:w-[calc(100%/6)] lg:w-[calc(100%/8)] bg-white rounded-lg p-2">
              <img className="pointer-events-none h-full w-full select-none object-contain" src="/images/medpart/9.png" alt="client"/>
            </div>

            <div className="relative h-12 lg:h-24 w-[calc(100%/4)] flex-shrink-0 select-none md:w-[calc(100%/6)] lg:w-[calc(100%/8)] bg-white rounded-lg p-2">
              <img className="pointer-events-none h-full w-full select-none object-contain" src="/images/medpart/10.png" alt="client"/>
            </div>

            <div className="relative h-12 lg:h-24 w-[calc(100%/4)] flex-shrink-0 select-none md:w-[calc(100%/6)] lg:w-[calc(100%/8)] bg-white rounded-lg p-2">
              <img className="pointer-events-none h-full w-full select-none object-contain" src="/images/medpart/1.png" alt="client"/>
            </div>

            <div className="relative h-12 lg:h-24 w-[calc(100%/4)] flex-shrink-0 select-none md:w-[calc(100%/6)] lg:w-[calc(100%/8)] bg-white rounded-lg p-2">
              <img className="pointer-events-none h-full w-full select-none object-contain" src="/images/medpart/2.png" alt="client"/>
            </div>

            <div className="relative h-12 lg:h-24 w-[calc(100%/4)] flex-shrink-0 select-none md:w-[calc(100%/6)] lg:w-[calc(100%/8)] bg-white rounded-lg p-2">
              <img className="pointer-events-none h-full w-full select-none object-contain" src="/images/medpart/3.png" alt="client"/>
            </div>

            <div className="relative h-12 lg:h-24 w-[calc(100%/4)] flex-shrink-0 select-none md:w-[calc(100%/6)] lg:w-[calc(100%/8)] bg-white rounded-lg p-2">
              <img className="pointer-events-none h-full w-full select-none object-contain" src="/images/medpart/4.png" alt="client"/>
            </div>

            <div className="relative h-12 lg:h-24 w-[calc(100%/4)] flex-shrink-0 select-none md:w-[calc(100%/6)] lg:w-[calc(100%/8)] bg-white rounded-lg p-2">
              <img className="pointer-events-none h-full w-full select-none object-contain" src="/images/medpart/5.png" alt="client"/>
            </div>
            
            <div className="relative h-12 lg:h-24 w-[calc(100%/4)] flex-shrink-0 select-none md:w-[calc(100%/6)] lg:w-[calc(100%/8)] bg-white rounded-lg p-2">
              <img className="pointer-events-none h-full w-full select-none object-contain" src="/images/medpart/6.png" alt="client"/>
            </div>

            <div className="relative h-12 lg:h-24 w-[calc(100%/4)] flex-shrink-0 select-none md:w-[calc(100%/6)] lg:w-[calc(100%/8)] bg-white rounded-lg p-2">
              <img className="pointer-events-none h-full w-full select-none object-contain" src="/images/medpart/7.png" alt="client"/>
            </div>

            <div className="relative h-12 lg:h-24 w-[calc(100%/4)] flex-shrink-0 select-none md:w-[calc(100%/6)] lg:w-[calc(100%/8)] bg-white rounded-lg p-2">
              <img className="pointer-events-none h-full w-full select-none object-contain" src="/images/medpart/8.png" alt="client"/>
            </div>

            <div className="relative h-12 lg:h-24 w-[calc(100%/4)] flex-shrink-0 select-none md:w-[calc(100%/6)] lg:w-[calc(100%/8)] bg-white rounded-lg p-2">
              <img className="pointer-events-none h-full w-full select-none object-contain" src="/images/medpart/9.png" alt="client"/>
            </div>

            <div className="relative h-12 lg:h-24 w-[calc(100%/4)] flex-shrink-0 select-none md:w-[calc(100%/6)] lg:w-[calc(100%/8)] bg-white rounded-lg p-2">
              <img className="pointer-events-none h-full w-full select-none object-contain" src="/images/medpart/10.png" alt="client"/>
            </div>

          </div>

        </div>
      </div>

      <div className="w-full mt-5 pt-7 md:pt-16 bg-dark  lg:w-[90%] lg:rounded-tr-[100px]">
        {/* footer */}
        <div className="flex flex-wrap px-3 lg:pl-10">
            <div className="mt-10 w-full lg:w-1/3">
                <h2 className="text-white lg:mb-11 font-bold text-2xl mb-5 md:text-3xl">Hubungi kami</h2>
                <p className="text-white mb-2 md:text-lg mb:mb-4">No Wa : 082133320489</p>
                <p className="text-white mb-2 md:text-lg mb:mb-4">Email : georgeikkirama@gmail.com</p>
                <p className="text-white mb-2 md:text-lg mb:mb-4">Alamat : Jl. Raya Dagan RT 03 RW 09</p>
            </div>

            <div className="mt-10 w-full sm:w-1/2 lg:w-1/3">
                <h2 className="text-white lg:mb-11 font-bold text-2xl mb-5 md:text-3xl">Tautan</h2>
                <div className="flex flex-wrap">
                    <a href="/"
                        className="text-white mb-4 w-full hover:text-red-500 hover:underline md:text-lg">Beranda</a>
                    <a href="/news"
                        className="text-white mb-4 w-full hover:text-red-500 hover:underline md:text-lg">Event</a>
                    <a href="#experience" className="text-white mb-4 w-full hover:text-red-500 hover:underline
                        md:text-lg">Berita</a>
                    <a href="/subscription"
                        className="text-white mb-4 w-full hover:text-red-500 hover:underline md:text-lg">Subscription</a>
                    <a href="/map"
                        className="text-white mb-4 w-full hover:text-red-500 hover:underline md:text-lg">Peta Interaktif</a>
                    <a href="/ragam-indonesia"
                        className="text-white mb-4 w-full hover:text-red-500 hover:underline md:text-lg">Ragam Indonesia</a>
                </div>
            </div>

            <div className="my-10 w-full sm:w-1/2 lg:w-1/3">
                <h2 className="text-white lg:mb-11 font-bold text-2xl mb-5 md:text-3xl">Social Media</h2>
                <div className="flex flex-wrap">
                    <a href="https://wa.me/+6282133320489"
                        className="text-white mb-4 w-full hover:text-red-500 hover:underline md:text-lg">WhatsApp</a>
                    <a href="https://github.com/IkkiRama"
                        className="text-white mb-4 w-full hover:text-red-500 hover:underline md:text-lg">GitHub</a>
                    <a href="https://www.instagram.com/george_ikki/"
                        className="text-white mb-4 w-full hover:text-red-500 hover:underline md:text-lg">Instagram</a>
                    <a href="https://www.youtube.com/channel/UCDYgvHIUtwRDRfS4srHFQDg"
                        className="text-white mb-4 w-full hover:text-red-500 hover:underline md:text-lg">Youtube</a>
                    <a href="https://www.linkedin.com/in/rifki-romadhan/"
                        className="text-white mb-4 w-full hover:text-red-500 hover:underline md:text-lg">LinkedIn</a>
                </div>
            </div>

            <footer
                className="text-white w-full text-center text-xs font-medium lg:text-lg py-5 lg:py-7 lg:mt-20">
                Dibuat dengan ❤️ oleh <a href="https://www.linkedin.com/in/rifki-romadhan"
                    className="hover:underline text-primary">Ngarah Osmo</a>. Hak cipta © 2024
            </footer>

        </div>
      </div>
    </footer>
  );
}
